import { getCategory, getSubcategory, getLocation, getNavDeviceType, isNavSticky } from './trackingUtils';
import { getUrlPath } from './urlUtils';
export function trackLinkClick(element, data = {}) {
    const onClick = () => {
        if (!data.trackFn) {
            return;
        }
        const properties = {
            currentPage: getUrlPath(),
            isNavSticky: isNavSticky(element),
            linkId: data.id,
            linkText: data.title,
            linkUrl: data.url?.includes('http') ? data.url : `${window.location.origin}${data.url}`,
            linkCategory: getCategory(element),
            linkSubcategory: getSubcategory(element),
            linkLocation: getLocation(element),
            navDeviceType: getNavDeviceType(element),
        };
        data.trackFn({
            eventName: 'Click Top Navigation Link',
            properties,
        });
    };
    element.addEventListener('click', onClick);
    return {
        update(updatedData) {
            data = updatedData;
        },
        destroy() {
            element.removeEventListener('click', onClick);
        },
    };
}
